import * as React from "react";
import { forwardRef } from "react";
const SvgClosesidebar = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15.79, height: 16.569, viewBox: "0 0 15.79 16.569", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m0 13.036 3.533-3.533.87.865-1.874 1.874H15.79v1.53H2.472l1.931 1.929-.87.868Zm7.02-5.384V6.12h8.771v1.532ZM6.43 1.53V.001h9.36v1.53Z", className: "saf0f48c6d022eca7f1e8799631428aee__a" }));
const ForwardRef = forwardRef(SvgClosesidebar);
export { ForwardRef as ReactComponent };
